export enum UserBonusCheckpointStatus {
  Created = 'created', // Bonus was created but not yet activated
  Fulfilled = 'fulfilled', // Bonus was fullfilled
  Claimed = 'claimed', // Bonus has been claimed by the user
}
